import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  .properties-of-interest {
    @media ${theme.mediaQuery.tabletMax} {
        justify-content: center;
    }
  }
`}
`;
